import {useState} from "react";


export default function useFetchNoUser() {

  const [loading, setLoading] = useState(true);
  const baseUrl = process.env.REACT_APP_BASE_URL ||  "http://127.0.0.1:8090/";
  function get(url) {

    return new Promise((resolve, reject) => {
      fetch(baseUrl + url,)
        .then(response => response.json())
        .then(data => {
          if (!data) {
            setLoading(false);
            return reject(data);
          }
          setLoading(false);
          resolve(data);
        })
        .catch(error => {
          setLoading(false);
          reject(error);
        });
    });
  }
  function post(url, body) {
    let headers = {
            "Content-Type": "application/json",
    }
    return new Promise((resolve, reject) => {
      fetch(baseUrl + url, {
        method: "post",
        headers: headers,
        body: JSON.stringify(body)
      })
        .then(response => response.json())
        .then(data => {
          if (!data) {
            setLoading(false);
            return reject(data);
          }
          setLoading(false);
          resolve(data);
        })
        .catch(error => {
          setLoading(false);
          reject(error);
        });
    });
  }

  return { get, post, loading };
};
